import { UserDTO } from "../users/user.dto";

export class HostProfileDTO {
  firstName: string = "";
  lastName: string = "";
  username: string = "";
  email: string = "";
  language: string = "";
  address: string = "";
  dob: string = "";
  city: string = "";
  state: string = "";
  zipCode: string = "";
  phone: string = "";
  gender: string = "";
  profilePicUrl: string = "";
  profilePicId!: number;
  businessPicId!: number;
  businessPicUrl: string = "";
  mission: string = ''
  businessName: string = "";
  businessEmail: string = "";
  businessPhoneNumber: string = "";
  businessWebsite: string = "";
  missionStatement: string = "";
  about: string = "";
  industry: string = "";
  industryAndInterests: string = "";
  businessAddress: string = "";
  membershipLevel: string = "";
  eventsHosted: number = 0;
  badgesEarned: number = 0;
  placeId: string = ''
  ambassadorReferralCode: string = "";
  profileCompleted: boolean = false;
  driverLicenseOrStateId: string="";
  driverLicenseFrontPicUrl: string = "";
  driverLicenseBackPicUrl: string = "";
  driverLicenseFrontPicId:string="";
  driverLicenseBackPicId: string = "";
  declarationAccepted: boolean = false;
  user: UserDTO = new UserDTO();

  constructor(data: Partial<HostProfileDTO> = {}){
    for(let key in data){
      if(key === 'user'){
        this[key] = new UserDTO(data[key]);
      }else{
        this[key] = data[key];
      }
    }
  }
}

export class EditHostProfileDTO{

    firstName: string = "";
    lastName: string = "";
    username: string = "";
    email: string = "";
    language: string = "";
    address: string = "";
    dob: string = "";
    city: string = "";
    state: string = "";
    zipCode: string = "";
    phone: string = "";
    gender: string = "";
    profilePicUrl: string = "";
    profilePicId!: number;
    businessPicId!: number;
    businessPicUrl: string = "";
    businessName: string = "";
    businessEmail: string = "";
    businessPhoneNumber: string = "";
    businessWebsite: string = "";
    missionStatement: string = "";
    about: string = "";
    industry: string = "";
    businessAddress: string = "";
    membershipLevel: string = "";
    eventsHosted: number = 0;
    badgesEarned: number = 0;
  
    ambassadorReferralCode: string = "";
    profileCompleted: boolean = false;
    driverLicenseOrStateId: string="";
    driverLicenseFrontPicUrl: string = "";
    driverLicenseBackPicUrl: string = "";
    driverLicenseFrontPicId:string="";
    driverLicenseBackPicId: string = "";
    declarationAccepted: boolean = false;

}